import { useIsMember } from '../../store/stateMachine/state'
import { Guest } from './Guest'
import { Member } from './Member'

export function UserInput() {
  const isMember = useIsMember()
  return isMember ? <Member /> : <Guest />
}
